export const customTranslations = {
  en: {
    translation: {
      top_games: "Top games",
      new_games: "New",
      play_online: "play-online",
    },
  },
  fr: {
    translation: {
      "homepage-personalized-games": "Recommandé Pour Vous",
      "homepage-trending-games": "À la mode maintenant",
      "homepage-new-releases": "Nouveaux jeux",
      "homepage-top-10-in-country": "Top 10 en",
      "homepage-favorite-game-tag": "Vos meilleurs jeux",
      "homepage-favorite-game-studio": "Vos favoris de",
      "homepage-megaways": "Des Mégaways que vous aimerez",
      "homepage-personalized-popular": "Jeux populaires pour vous",
      "homepage-similar-games": "Parce que vous avez joué à",
      top_games: "Meilleurs jeux",
      new_games: "Nouveau",
      play_online: "jouer-en-ligne",
    },
  },
  de: {
    translation: {
      "homepage-personalized-games": "Für dich empfohlen",
      "homepage-trending-games": "Derzeit im Trend",
      "homepage-new-releases": "Neue Spiele",
      "homepage-top-10-in-country": "Top 10 in der",
      "homepage-favorite-game-tag": "Deine Top Spiele",
      "homepage-favorite-game-studio": "Deine Favoriten von",
      "homepage-megaways": "Megaways, die dir gefallen werden",
      "homepage-personalized-popular": "Beliebte Spiele für dich",
      "homepage-similar-games": "Weil du gespielt hast",
      top_games: "Beste Spiele",
      new_games: "Neu",
      play_online: "online-spielen",
    },
  },
  it: {
    translation: {
      "homepage-personalized-games": "Consigliati per te",
      "homepage-trending-games": "Popolari",
      "homepage-new-releases": "Nuovi giochi",
      "homepage-top-10-in-country": "Top 10 in",
      "homepage-favorite-game-tag": "I tuoi migliori giochi",
      "homepage-favorite-game-studio": "I tuoi preferiti da",
      "homepage-megaways": "Megaways che ti piaceranno",
      "homepage-personalized-popular": "Giochi popolari per te",
      "homepage-similar-games": "Perché hai giocato a",
      top_games: "I migliori giochi",
      new_games: "Nuovo",
      play_online: "giocare-online",
    },
  },
};
